import gql from 'graphql-tag';

export type MultiGetSkillsResponse = {
  MultiGetSkillsResponse: {
    skills: { skillId: string; isEligibleForScoring: boolean }[];
  };
};

export type MultiGetSkillsVariables = {
  input: {
    skillIds: string[];
  };
};

export const MultiGetSkillsQuery = gql`
  query SkillsDataQuery($input: MultiGetSkillsVariables!) {
    MultiGetSkillsResponse(input: $input)
      @rest(type: "MultiGetSkillsResponse", path: "grpc/skills/v2/SkillsAPI/MultiGetSkills", method: "POST") {
      skills {
        skillId
        isEligibleForScoring
      }
    }
  }
`;
